import { render, staticRenderFns } from "./PublicVerification.vue?vue&type=template&id=359227b4&scoped=true"
import script from "./PublicVerification.vue?vue&type=script&lang=js"
export * from "./PublicVerification.vue?vue&type=script&lang=js"
import style0 from "./PublicVerification.vue?vue&type=style&index=0&id=359227b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359227b4",
  null
  
)

export default component.exports